"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsnCollectionRule = void 0;
/** How a loan application's PII step obtains each applicant's full SSN. */
var SsnCollectionRule;
(function (SsnCollectionRule) {
    /** The applicant gives a full SSN, or its last 4 for Aven to complete through IDology */
    SsnCollectionRule["required"] = "required";
    /** As `required`, but a loan officer may leave it blank for Aven to try deriving it from MethodFi's identity */
    SsnCollectionRule["optional"] = "optional";
    /** No SSN is given; Aven derives it from MethodFi's identity or the PII step can't proceed */
    SsnCollectionRule["derivedOnly"] = "derivedOnly";
})(SsnCollectionRule || (exports.SsnCollectionRule = SsnCollectionRule = {}));
